import React,{useEffect,useState} from 'react';
import { ChakraProvider, useDisclosure } from "@chakra-ui/react";
import theme from "./theme";
// import Layout from "./components/Layout";
// import ConnectButton from "./components/ConnectButton";
// import AccountModal from "./components/AccountModal";
// import UniswapWidget from "./components/UniswapWidget";
import Header from "./components/Header";
import "@fontsource/inter";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import ThemeSwitch from "./components/ThemeSwitch";
import {Box,} from '@chakra-ui/react';
import eventBus from "./eventBus";
import Graph from './components/Graph';
// import { Provider } from "react-redux";
// import { notesReducer} from './reducer.js';
// import { reducer,initialState} from './reducer';

import { StateProvider } from './StateProvider.js';
import { reducer,initialState} from './reducer.js';

function App() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [theme, setTheme] = useState('');
  useEffect(() => {
    if(localStorage.getItem('theme')==='dark'){
      setTheme('light');
    }else if(localStorage.getItem('theme')==='light'){
      setTheme('dark');
    }
    eventBus.on("changeTheme", (data: any) =>{
      if(data.message==='dark'){
        setTheme('light');
      }else if(data.message==='light'){
        setTheme('dark');
      }
    });
},[theme]);
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ChakraProvider>
        {/* <Layout>
          <ConnectButton handleOpenModal={onOpen} />
          <AccountModal isOpen={isOpen} onClose={onClose} />
          <UniswapWidget />
        
        </Layout> */}
        <Box style={theme==='light' ? {backgroundImage: `url("images/bg_img.png")`}:{backgroundImage: `url("images/bg.png")`}}>
          
          <Header/>
          {/* <Graph /> */}
          <Banner/>
        </Box>
        <Footer/>
        <ThemeSwitch/>
      </ChakraProvider>
    </StateProvider> 
  );
}

export default App;
